document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-curete-loyalty]');
  if (!root) return;

  const panel = root.querySelector('[data-loyalty-panel]');
  const overlay = root.querySelector('[data-loyalty-overlay]');
  const openBtn = root.querySelector('[data-loyalty-toggle]');
  const closeBtn = root.querySelector('[data-loyalty-close]');
  const pointsEl = root.querySelector('[data-loyalty-points]');
  const levelEl = root.querySelector('[data-loyalty-level]');
  const messageEl = root.querySelector('[data-loyalty-message]');
  const actionBtns = root.querySelectorAll('[data-action-btn]');

  const toast = root.querySelector('[data-loyalty-toast]');
  const toastTitle = root.querySelector('[data-toast-title]');
  const toastText = root.querySelector('[data-toast-text]');

  const levelupModal = root.querySelector('[data-levelup-modal]');
  const levelupTitle = root.querySelector('[data-levelup-title]');
  const levelupText = root.querySelector('[data-levelup-text]');
  const levelupCloseBtns = root.querySelectorAll('[data-levelup-close]');

  const customerId = root.dataset.customerId || '';
  const workerUrl = root.dataset.workerUrl || '';
  let currentPoints = parseInt(root.dataset.points || '0', 10);
  let currentLevel = root.dataset.level || 'Level 1';
  let toastTimer = null;

  function calculateLevel(points) {
    if (points >= 75000) return 'Level 8';
    if (points >= 50000) return 'Level 7';
    if (points >= 24000) return 'Level 6';
    if (points >= 12000) return 'Level 5';
    if (points >= 6000) return 'Level 4';
    if (points >= 3000) return 'Level 3';
    if (points >= 1000) return 'Level 2';
    return 'Level 1';
  }

  function getLevelRank(level) {
    const ranks = {
      'Level 1': 1,
      'Level 2': 2,
      'Level 3': 3,
      'Level 4': 4,
      'Level 5': 5,
      'Level 6': 6,
      'Level 7': 7,
      'Level 8': 8
    };
    return ranks[level] || 0;
  }

  function getLevelMessage(level) {
    switch (level) {
      case 'Level 2':
        return 'You unlocked Level 2 and moved one step closer to stronger rewards.';
      case 'Level 3':
        return 'You unlocked Level 3 with better discounts and early access benefits.';
      case 'Level 4':
        return 'You reached Level 4 ⚡. From now on, every EGP earns 2 points.';
      case 'Level 5':
        return 'You unlocked Level 5 with premium rewards and 2× earning rate.';
      case 'Level 6':
        return 'You reached Level 6 with elite-tier benefits and 2× earning rate.';
      case 'Level 7':
        return 'You unlocked Level 7 with top-tier exclusive rewards.';
      case 'Level 8':
        return 'You reached Level 8 — the pinnacle of the CURETÉ loyalty program.';
      default:
        return 'You unlocked a new loyalty level.';
    }
  }

  function setMessage(text, isError) {
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.style.color = isError ? '#ffb3b3' : '';
  }

  function showToast(title, text) {
    if (!toast) return;

    if (toastTitle) toastTitle.textContent = title;
    if (toastText) toastText.textContent = text;

    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 4000);
  }

  function showLevelupModal(title, text) {
    if (!levelupModal) return;

    if (levelupTitle) levelupTitle.textContent = title;
    if (levelupText) levelupText.textContent = text;

    levelupModal.classList.add('is-visible');
    levelupModal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeLevelupModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (!levelupModal) return;

    levelupModal.classList.remove('is-visible');
    levelupModal.setAttribute('aria-hidden', 'true');

    if (!root.classList.contains('is-open')) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

function updateUI(newPoints) {
  currentPoints = newPoints;
  currentLevel = calculateLevel(newPoints);

  if (pointsEl) pointsEl.textContent = currentPoints;
  if (levelEl) levelEl.textContent = currentLevel;

  window.dispatchEvent(
    new CustomEvent('curete:loyalty-points-updated', {
      detail: {
        points: currentPoints,
        level: currentLevel
      }
    })
  );
}

  function openPanel(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    root.classList.add('is-open');

    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
    }

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closePanel(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    root.classList.remove('is-open');

    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
    }

    if (!levelupModal || !levelupModal.classList.contains('is-visible')) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  async function rewardAction(action, bonusPoints, btn) {
  if (!customerId) {
    setMessage('Please log in first to use loyalty actions.', true);
    return;
  }

  if (!workerUrl) {
    setMessage('Worker URL is missing.', true);
    return;
  }

  btn.classList.add('is-loading');
  setMessage('Processing reward...', false);

  try {
    const response = await fetch(
      `${workerUrl}?customer_id=${encodeURIComponent(customerId)}&action=${encodeURIComponent(action)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customer_id: customerId,
          action: action
        })
      }
    );

    const text = await response.text();

    let workerData = null;

    try {
      workerData = JSON.parse(text);
    } catch (err) {
      // keep as null if response is not valid JSON
    }

    if (!response.ok) {
      throw new Error(
        workerData?.error ||
        workerData?.message ||
        text ||
        'Reward request failed'
      );
    }

    if (workerData && workerData.blocked) {
      const hoursLeft = workerData.hours_left ? ` Try again in ${workerData.hours_left} hours.` : '';
      throw new Error(`You already claimed this reward today.${hoursLeft}`);
    }

    let newPoints = currentPoints + bonusPoints;

    if (workerData && typeof workerData.total_points !== 'undefined') {
      newPoints = parseInt(workerData.total_points, 10);
    } else if (workerData && typeof workerData.points !== 'undefined') {
      newPoints = parseInt(workerData.points, 10);
    }

    updateUI(newPoints);

    if (workerData && workerData.level_up) {
      const unlockedLevel = `Level ${workerData.level}`;
      const message = getLevelMessage(unlockedLevel);

      showToast(`Unlocked ${unlockedLevel}`, message);

      if (
        unlockedLevel === 'Level 4' ||
        unlockedLevel === 'Level 7' ||
        unlockedLevel === 'Level 8'
      ) {
        showLevelupModal(`Congratulations! ${unlockedLevel} Unlocked`, message);
      }
    }

    btn.classList.remove('is-loading');
    btn.classList.add('is-done');
    setMessage('Reward added successfully.', false);

    setTimeout(function () {
      btn.classList.remove('is-done');
    }, 1500);
  } catch (error) {
    btn.classList.remove('is-loading');
    setMessage(error.message || 'Something went wrong.', true);
  }
}

  if (openBtn) {
    openBtn.addEventListener('click', openPanel);

    openBtn.addEventListener(
      'touchstart',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false }
    );

    openBtn.addEventListener('touchend', openPanel, { passive: false });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closePanel);
  }

  if (overlay) {
    overlay.addEventListener('click', closePanel);
    overlay.addEventListener('touchend', closePanel, { passive: false });
  }

  levelupCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', closeLevelupModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closePanel();
      closeLevelupModal();
    }
  });

  actionBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const action = btn.dataset.action;
      const url = btn.dataset.url;
      const bonusPoints = parseInt(btn.dataset.points || '50', 10);

      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }

      rewardAction(action, bonusPoints, btn);
    });

    btn.addEventListener(
      'touchend',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        const action = btn.dataset.action;
        const url = btn.dataset.url;
        const bonusPoints = parseInt(btn.dataset.points || '50', 10);

        if (url) {
          window.open(url, '_blank', 'noopener,noreferrer');
        }

        rewardAction(action, bonusPoints, btn);
      },
      { passive: false }
    );
  });
});